module.exports = new __parcel__URL__("error.4fa1b24b.svg").toString();